import RunningProcess, { RunningProcessArgument } from "./running_process";

import type { DateLike, ModifyPartial } from "type_aliases";

type ProcessArgument = RunningProcessArgument & ModifyPartial<Process, {
  startTime: DateLike
  endTime: DateLike
}>

export class Process extends RunningProcess {
  constructor({ projectId, floorId, scanDatasetId, ifcType, pdfType, name, startTime, startDate, endTime, endDate, updates, status }: ProcessArgument = {}) {
    super({ id: null, startDate: startDate || startTime, endDate: endDate || endTime, updates, status, name });
    this.projectId = projectId;
    if (floorId) {
      this.floorId = floorId;
    }
    if (scanDatasetId) {
      this.scanDatasetId = scanDatasetId;
    }
    if (ifcType) {
      this.ifcType = ifcType;
    }
    if (pdfType) {
      this.pdfType = pdfType;
    }
  }

  projectId: string;
  floorId?: string;
  scanDatasetId?: string;
  ifcType?: string;
  pdfType?: string;
}

export class RunningProcessWithId extends Process {
  constructor(process: Partial<RunningProcess & { processId: number }> = {}) {
    super(process);
    this.processId = process.processId;
  }

  processId: number;
}

export class RunningProcessWithName extends Process {
  constructor(process: Partial<RunningProcess & { processName: string }> = {}) {
    super(process);
    this.processName = process.processName;
  }

  processName: string;
}

export type ProcessTypes =
  | RunningProcessWithId
  | RunningProcessWithName
